import { fromPairs, toPairs, filter, pipe } from 'ramda'

const skipNullValues = pipe(
  toPairs,
  filter(([, value]) => value !== null && value !== undefined),
  fromPairs
)

export default skipNullValues
